import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { extractQueryParams } from "../utils/getAllURLParameters";
import { decodeBase64Url } from "../utilFunction/decodeUtils";
import AntheLogo1 from "../assets/antheLogo1.png";
import AntheLogo2 from "../assets/antheLogo2.png";
import Akthelogo from "../assets/akthe_logo_2025.png";
import styles from "./anthe.module.css";
import callIcon from "../assets/call.png";
import branch_icon1 from "../assets/branch_icon2.png";
import branch_icon2 from "../assets/early-bird-icon1.png";
import branch_icon3 from "../assets/branch_icon3.png";
import airBadge from "../assets/air_badge.png";
import stateBadge from "../assets/state_badge.png";
import AB443 from "../assets/qrcode-images/AB443.jpg";
import config from "../config";
import branchGrade from "../assets/branch-grade.png"
import ECAClass10Engg from '../assets/cashaward/ECAClass10Engg.png'
import ECAClass10Medical from '../assets/cashaward/ECAClass10Medical.png'
import ECAClass789 from '../assets/cashaward/ECAClass789.png'
import ECAClass1112Engg from '../assets/cashaward/ECAClass1112Engg.png'
import ECAClass1112Medical from '../assets/cashaward/ECAClass1112Medical.png'
import Antheheading from '../assets/antheseniorjunior.svg'
import ECAClass10jrsr from '../assets/cashaward/ECAClass10juniorsenior.png'
import ECAClass789jrsr from '../assets/cashaward/ECAClass789juniorsenior.png'
import ECAClass56jrsr from '../assets/cashaward/ECAClass56juniorsenior.png'
import ECAClass1112jrsr from '../assets/cashaward/ECAClass1112juniorsenior.png'
import Kashmirtext from '../assets/Kashmor_text.png'
import AktheCA10 from '../assets/akthe_CA_10.png'
import AKTHECA789 from '../assets/akthe_CA_789.png'
import AKTHECA1112 from '../assets/akthe_CA_1112.png'
import Akthebadge from '../assets/Akthe_Badge.png'


function AntheResultPage1_Qualified({ isStudentPDF = true, Response }) {
  const [decodedData, setDecodedData] = useState(null);
  const contacts = Response.centerData.center_detail.contact_numbers;
  // Initialize an empty string to store the formatted output
  let formattedOutput = "";
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedUrl = urlParams.get("data");

    if (encodedUrl) {
      const decodedData = decodeBase64Url(encodedUrl);
      decodedData.exam_type = decodedData.exam_type || "ANTHE";
      setDecodedData(decodedData);
      document.title =
        decodedData.exam_type === "AKTHE" ? "AKTHE Result" : "ANTHE Result";
    }

    // eslint-disable-next-line
  }, []);
  // Iterate through the array, grouping two indexes per line
  for (let i = 0; i < contacts.length; i += 2) {
    const firstContact = contacts[i];
    const secondContact = contacts[i + 1];

    // Check if the second contact exists (it may be undefined if there are an odd number of elements)
    if (secondContact !== undefined) {
      formattedOutput += `${firstContact}, ${secondContact}\n`;
    } else {
      formattedOutput += `${firstContact}\n`;
    }
  }
  const imagePath = `/static/media/${Response.profile.branch_id}.jpg`;
let eligibleRankForCashAward = {};
  if (decodedData?.exam_type === "AKTHE" ) {
    eligibleRankForCashAward = {
    'VII': 3,
    'VIII': 3,
    'IX': 3,
    'X': 3,
    'XI': 3,
    'XII': 3,
    'XII Passed': 3
  };
  }
  if (decodedData?.exam_type === "ANTHE" ) {
    eligibleRankForCashAward = {
    'V': 50,
    'VI': 50,
    'VII': 250,
    'VIII': 250,
    'IX': 250,
    'X': 250,
    'XI': 100,
    'XII': 100,
    'XII Passed': 100
  };
  }
  if (Response?.profile?.anthetwo) {
    eligibleRankForCashAward = { 'V': 50, 'VI': 50, 'VII': 50, 'VIII': 50, 'IX': 50, 'X': 50, 'XI': 25, 'XII': 25, 'XII Passed': 25 }
  }
  return (
    <div style={{ fontFamily: "Outfit-Regular" }}>
      <div className="mx-auto">
        <Row className="bg-dark-blue p-4 mb-3">
          <Col xs={3}>
           
            {decodedData?.exam_type === "AKTHE" ? (
              <img width="100%" src={Akthelogo} alt="anthe logo - akthe" />
            ) : (
              <img width="100%" src={AntheLogo2} alt="anthe logo - default" />
            )}
          </Col>
          <Col
            className="align-self-center text-start"
            xs={7}
            style={{ padding: "4%", lineHeight: "1.2" }}
          >
            {!Response?.profile?.anthetwo ? (
              <>
                <p
                  className="font-size-sm font-size-lg-45 font-size-xl-45"
                  style={{
                    fontWeight: "500",
                    fontFamily: "Outfit-Regular",
                    margin: 0,
                    color: "white",
                  }}
                >
                  Aakash National
                </p>
                <p className={`${styles.page1_cardHeading_2} font-size-xl font-size-lg-60 font-size-xl-60`}>
                  Talent Hunt Exam
                </p>
                {
                  decodedData?.exam_type === 'AKTHE' ? <p className=""><img src={Kashmirtext} alt="text" width="40%" /></p> : ""
                }
              </>
            ) : (
              <img src={Antheheading} alt="heading" width="80%" />
            )}
          </Col>
          <Col xs={2} className="text-center">
            <img width={"210px"} src={AntheLogo1} alt="anthe logo" />
          </Col>
        </Row>
        <div className="mx-5 mt-2">
          {/* {isStudentPDF ? (
            <div className="my-4">
              <h2 className={`${styles.page1_congratsText} text-start`}>
                Congratulations!
              </h2>

              <h3 className={`${styles.page1_congratsSubText} text-start `}>
                You have Qualified for Scholarship based on your ANTHE Score. !
              </h3>
            </div>
          ) : */}{(
            <Row className={`${styles.page1_boxRounded} bg-light-yellow-10 justify-content-center`}>
              <Col
                lg={12}
                className="d-flex rounded-10px m-1 flex-column ps-4 pe-5"
                style={{ alignContent: "center" }}
              // style={{ width: "-webkit-fill-available" }}
              >
                <h2 className={`${styles.page1_congratsText} text-center`}>
                  Congratulations!
                </h2>
                <Col
                  className={`${styles.page1_tableBottomText} fw-lighter text-dark-blue-200 font-size-xl text-center`}
                >
                  {Response?.scholarship?.remarks}
                </Col>
                <Col lg={12}
                  className="text-center fw-lighter font-size-xxl mb-2 bg-dark-blue text-white rounded-10px p-2 mt-2 m-2"
                  style={{ letterSpacing: "1px" }}
                >
                  Limited Seats. Admission is on a First Come, First Serve Basis. Valid until <span style={{ color: "#FFD600" }}>{config.VALIDTILL} {config.YEAR}</span>
                </Col>
                <Col
                  lg={12}
                  className="d-flex bg-white rounded-10px p-3 m-2 mt-2 text-start"
                >
                  <Col
                    lg={5}
                    className="m-2 pe-2"
                    style={{ borderRight: "1px solid" }}
                  >
                    <Col
                      className={`${styles.page1_addressHeading} font-size-28`}
                    >
                      {decodedData?.exam_type === "AKTHE" ? "Center Address:" : "Branch Address:"}
                    </Col>
                    <Col className="font-size-lg fw-bold">
                      {Response.centerData.center_detail.address}
                    </Col>
                  </Col>
                  <Col lg={5} className="m-2 ms-3">
                    <Col
                      className={`${styles.page1_addressHeading} font-size-28`}
                    >
                      {decodedData?.exam_type === "AKTHE" ? "Centre Contact Details:" : " Branch / Center Contact:"}
                    </Col>
                    <Col
                      sm={10}
                      className="font-size-lg fw-bold"
                      style={{ letterSpacing: "1px", lineHeight: "2rem" }}
                    >
                      {formattedOutput}
                    </Col>
                  </Col>
                  <Col
                    lg={3}
                    className="flex-column
                    justify-content-center d-flex"
                    style={{
                      position: "relative",
                      right: "1rem",
                      height: "10rem",
                    }}
                  >
                    <Col>
                      <img style={{ width: "45%" }} width={100} src={Response?.centerData?.center_detail?.qr_code} />
                    </Col>
                    <Col className="font-size-xs w-5 ps-3 mt-0">
                    Scan the QR code and 
        get the centre location 
        in your Google Maps
                    </Col>
                  </Col>
                </Col>
              </Col>
              <Row className={decodedData?.exam_type == "ANTHE" ? "" : "mb-3 " + "mt-0 mx-auto px-4"}>
                <div
                  className={`${styles.page1_ResultHead} p-2 bg-blue-200 w-100 text-center text-white font-size-xl`}
                >
                  VISIT YOUR NEAREST BRANCH FOR
                </div>
                <Row className="w-100 m-auto p-0 py-3 d-flex justify-content-center bg-grey-light dashed-border">
                  <Col
                    md={3}
                    lg={2}
                    className="text-center rounded-5 bg-red p-3 d-flex flex-column align-items-center m-2 mt-0 bg-light-yellow-100 justify-content-center mx-4"
                    style={{ height: "12rem" }}
                  >
                    <img width={40} src={branch_icon3} />
                    <p className="font-size-md-max mt-2">
                      ACADEMIC
                      <br />
                      COUNSELLING
                    </p>
                  </Col>
                  <Col
                    md={3}
                    lg={2}
                    className="text-center rounded-5 bg-red p-3 d-flex flex-column align-items-center m-2 mt-0 bg-light-purple-100 justify-content-center mx-4"
                    style={{ height: "12rem" }}
                  >
                    <img width={40} src={branch_icon2} />
                    <p className="font-size-md-max mt-2">
                      DETAILS OF EARLY ADMISSION BENEFITS
                      {/* <br />
                                    RESULT ANALYSIS */}
                    </p>
                  </Col>
                  <Col
                    md={3}
                    lg={2}
                    className="text-center rounded-5 bg-red p-3 d-flex flex-column align-items-center m-2 mt-0 bg-light-green justify-content-center mx-4"
                    style={{ height: "12rem" }}
                  >
                    <img width={40} src={branch_icon1} />
                    <p className="font-size-md-max mt-2">
                      SCHOLARSHIP/FEE
                      <br />
                      DETAILS
                    </p>
                  </Col>
                  <h4 className="text-blue-200 mb-0 fw-bold mt-1">Now is the time to create your <span className="text-dark-blue-200 text">"SUCCESS KA ACTION PLAN"</span></h4>
                </Row>
              </Row>
              <p className='text-grey' style={{fontSize:"11px", margin:"0"}}>**By viewing this result, you (or your parent/guardian, if you are under 18) hereby provide consent to AESL to contact you via phone, email, SMS, or other communication channels for the purpose of sharing information, updates, and promotional material related to our services until 31st July 2026. You have the right to withdraw your consent at any time by contacting us at <a className='text-decoration-none' href='mailto:care@aesl.in'>care@aesl.in</a>.</p>
            </Row>
          )}
          <Row className="my-0 p-0">
            <div
              className={`${styles.page1_ResultHead}  p-1 bg-dark-blue w-100 text-center text-white font-size-30`}
            >
              RESULT
            </div>
            <Row className="w-100 m-auto p-0">
              <Col
                className={`${styles.page1_tableHead} dashed-borderLeft font-size-xxl text-center fw-bold`}
              >
                {"FOR CLASS " +
                  Response.profile.class_studying +
                  " STUDYING STUDENT"}
              </Col>
              <Col
                className={`${styles.page1_tableHead} dashed-borderLeft dashed-borderRight font-size-xxl text-center fw-bold`}
              >
                DETAILS OF ANTHE-{config.YEAR} SCORECARD
              </Col>
            </Row>
            <Row
              className="w-100 m-auto dashed-border p-0"
              style={{
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              <Col
                lg={6}
                className="d-flex p-0 dashed-borderRight dashed-borderBottom"
              >
                <Col
                  className={`${styles.page1_tableColumn} dashed-borderRight font-size-xl text-start `}
                >
                  <Col className="ps-4 fw-bold">Roll No. </Col>
                  <Col className={`${`${styles.page1_highlightedText} ps-4 fw-bold`}`}> PSID </Col>
                  <Col
                    className="ps-4 fw-bold"
                  >
                    Name of Candidate
                  </Col>
                  {decodedData?.exam_type !== "ANTHE" && (
                  <Col className={`${`${styles.page1_highlightedText} ps-4 fw-bold`}`}>Father's Name</Col>
                  )}
                  <Col
                      className={`ps-4 fw-bold ${
                        decodedData?.exam_type === "ANTHE" ? styles.page1_highlightedText : ""
                      }`}
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Stream / Class Opted{" "}
                  </Col>
                </Col>
                <Col
                  className={`${styles.page1_tableColumn} font-size-xl text-center `}
                >
                  <Col
                    className="text-start ps-3"
                    style={{ whiteSpace: "nowrap", height: "67px" }}
                  >
                    {" "}
                    {Response.profile.roll_number}
                  </Col>
                  <Col className={`${styles.page1_highlightedText} text-start ps-3`} style={{ height: "65px" }}>
                    {(Response.profile.psId ? Response.profile.psId : "NA")}
                  </Col>
                  <Col
                    className="text-start ps-3" style={{ height: "67px" }}
                  >
                    {Response.profile.name}
                  </Col>
                     {decodedData?.exam_type !== "ANTHE" && (
                  <Col className={`${`${styles.page1_highlightedText} text-start ps-3`}`} style={{ height: "65px" }}>
                    {Response.profile.father_name}
                  </Col>
                     )}
                  <Col
                     className={`text-start ps-3 ${
                        decodedData?.exam_type === "ANTHE" ? styles.page1_highlightedText : ""
                      }`}
                    style={{ whiteSpace: "nowrap", height: "65px" }}
                  >
                    {(Response.profile.stream === 'SOF'
                      ? 'Foundation'
                      : (Response.profile.stream === 'SOM'
                        ? 'Medical'
                        : 'Engineering')
                    ) + " : Class " + Response.profile.class_opted
                    }
                  </Col>
                </Col>
              </Col>
              <Col lg={6} className="d-flex p-0 dashed-borderBottom">
                <Col className="d-flex p-0">
                  <Col
                    className={`${styles.page1_tableColumn} dashed-borderRight font-size-lg text-start lh-md_max fw-bold`}
                  >
                    <Col className="ps-3 dashed-borderBottom p-2">
                      Your Grade
                    </Col>
                    <Col className="ps-3 dashed-borderBottom p-2">
                      Your Scholarship Percentage
                    </Col>
                    {/* <Col className="ps-4">Your Score</Col> */}
                    {isStudentPDF ? (
                      <>
                        <Col
                          style={{ whiteSpace: "nowrap" }}
                          className={`${`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2`}`}
                        >
                          <img className="me-2" src={stateBadge} width={20} />
                          {"ANTHE Rank (" + Response?.scholarship?.city + ")"}
                        </Col>
                        <Col
                          style={{ whiteSpace: "nowrap" }}
                          className={`${`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2`}`}
                        >
                          <img className="me-2" src={stateBadge} width={20} />
                          {"ANTHE Rank (" + Response.profile.state + ")"}
                        </Col>
                        <Col
                          style={{ whiteSpace: "nowrap" }}
                          className={`${`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2`}`}
                        >
                          <img className="me-2" src={airBadge} width={20} />
                          All India ANTHE Rank
                        </Col>
                      </>
                    ) : (

                      <>
                        {decodedData?.exam_type === "AKTHE" ? (
                          // For AKTHE: Only show AIR rank
                          <Col
                            style={{ whiteSpace: "nowrap", height: "200px" }}
                            className={`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2 pb-3`}
                          >
                            <img className="me-2" src={Akthebadge} width={20} />
                            {"ANTHE Rank (Kashmir)"}
                          </Col>
                        ) : (
                          <>
                            <Col
                              style={{ whiteSpace: "nowrap" }}
                              className={`${`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2 dashed-borderBottom`}`}
                            >
                              <img className="me-2" src={stateBadge} width={20} />
                              {"ANTHE Rank (" + Response?.scholarship?.city + ")"}
                            </Col>
                            <Col
                              style={{ whiteSpace: "nowrap" }}
                              className={`${`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2 dashed-borderBottom`}`}
                            >
                              <img className="me-2" src={stateBadge} width={20} />
                              {"ANTHE Rank (" + Response?.profile?.state + ")"}
                            </Col>
                            <Col
                              style={{ whiteSpace: "nowrap" }}
                              className={`${`${styles.page1_highlightedText} ps-3 d-flex align-items-center text-dark-blue-200 p-2 pb-3`}`}
                            >
                              <img className="me-2" src={airBadge} width={20} />
                              All India ANTHE Rank
                            </Col>
                          </>
                        )}
                      </>
                    )}
                  </Col>

                  <Col
                    className={`${styles.page1_tableColumn} font-size-xl text-center lh-md_max fw-bold`}
                  >
                    <Col style={{ lineHeight: "52px", height: "65px" }} className="dashed-borderBottom p-1 pb-2 ps-4">
                      {Response?.grade || '--'}
                    </Col>
                    <Col style={{ lineHeight: "56px", height: "65px" }} className="dashed-borderBottom p-1 ps-4">
                      {Response?.scholarship?.tuitionFee || 0}% *
                    </Col>
                    {/* <Col>{Response.total_score}</Col> */}
                    {isStudentPDF ? (
                      <>
                        <Col
                          className={`${`${styles.page1_highlightedText} text-dark-blue-200 p-2 dashed-borderBottom`}`}
                        >
                          {Response?.scholarship?.cityRank != "null" ? Response.scholarship.cityRank : "--"}
                        </Col>
                        <Col
                          className={`${`${styles.page1_highlightedText} text-dark-blue-200 p-2 dashed-borderBottom`}`}
                        >
                          {Response.scholarship.stateRank || "--"}
                        </Col>
                        <Col
                          className={`${`${styles.page1_highlightedText} text-dark-blue-200 p-2`}`}
                        >
                          {Response.scholarship.allIndiaRank || "--"}
                        </Col>
                      </>
                    ) : (
                      <>
                        {decodedData?.exam_type === "AKTHE" ? (
                          // For AKTHE: Only show AIR rank
                          <Col
                            style={{ lineHeight: "176px", height: "200px" }}
                            className={`${`${styles.page1_highlightedText} text-dark-blue-200 align-items-center p-1 dashed-borderBottom`}`}
                          >
                             {Response.scholarship.stateRank || "--"}
                          </Col>
                        ) : (
                          <>
                            <Col style={{ lineHeight: "56px", height: "65px" }}
                              className={`${`${styles.page1_highlightedText} text-dark-blue-200 p-1 dashed-borderBottom`}`}
                            >
                              {Response?.scholarship?.cityRank != "null" ? Response.scholarship.cityRank : "--"}
                            </Col>
                            <Col style={{ lineHeight: "56px", height: "65px" }}
                              className={`${`${styles.page1_highlightedText} text-dark-blue-200 p-1 dashed-borderBottom`}`}
                            >
                              {Response?.scholarship?.stateRank || "--"}
                            </Col>
                            <Col style={{ lineHeight: "61px", height: "65px" }}
                              className={`${`${styles.page1_highlightedText} text-dark-blue-200 p-1`}`}
                            >
                              {Response.scholarship.allIndiaRank || "--"}
                            </Col>
                          </>
                        )}
                      </>
                    )}
                  </Col>
                </Col>
              </Col>
              {/* {!isStudentPDF && (
                <Col
                  lg={12}
                  className="d-flex p-0 bg-light-yellow rounded-10px m-2 flex-column p-3"
                  // style={{ width: "-webkit-fill-available" }}
                >
                  <Col
                    className={`${styles.page1_tableBottomText} fw-lighter text-dark-blue-200 font-size-3xl text-center`}
                  >
                    YOU ARE ELIGIBLE FOR
                  </Col>
                  <Col className="text-center fw-lighter font-size-xxl">
                    {Response.scholarship.remarks || ""}
                  </Col>
                </Col>
              )} */}

            </Row>
            <Col className="ps-0" style={{ paddingRight: "1px" }}><img src={branchGrade} alt="branchgrade" className="img-fluid" /></Col>
            {!Response?.profile?.anthetwo ? (
              <div className='p-0'>
                {(Response?.scholarship?.allIndiaRank && Response?.profile?.class_studying && eligibleRankForCashAward[Response?.profile?.class_studying] && Number(Response?.scholarship?.allIndiaRank) <= eligibleRankForCashAward[Response?.profile?.class_studying]) ?
                  <> {Response?.profile?.class_studying == 'X' && (
                    <div className='mt-3 mt-lg-2 p-0'>
                      {decodedData?.exam_type === "AKTHE" ? (
                        <img
                          src={AktheCA10}
                          alt="AKTHE - Cash awards"
                          className="desktopview img-fluid"
                        />
                      ) : (
                        <>
                      {Response?.profile?.stream === "SOE" ? (
                          <img src={ECAClass10Engg} alt="cash awards" className="desktopview img-fluid" />
                        ) : (
                          <img src={ECAClass10Medical} alt="cash awards" className="desktopview img-fluid" />
                        )}
                        </>

                      )}
                    </div>
                  )}
                    {/* For Class VII, VIII & IX Studying Students */}
                    {(Response?.profile?.class_studying == 'VII' || Response?.profile?.class_studying == 'VIII' || Response?.profile?.class_studying == 'IX') && (
                      <div className='mt-3 mt-lg-2 p-0'>
                        {decodedData?.exam_type === "AKTHE" ? (
                          <img
                            src={AKTHECA789}
                            alt="AKTHE - Cash awards"
                            className="desktopview img-fluid"
                          />
                        ) : (
                          <img src={ECAClass789} alt="cash awards" className='desktopview img-fluid' />
                        )}
                      </div>
                    )}
                    {/* For Class XI & XII Studying & XII Passed Students (Medical & Engineering Aspirants) */}
                    {(Response?.profile?.class_studying == "XI" || Response?.profile?.class_studying == 'XII' || Response?.profile?.class_studying == 'XII Passed') && (
                      <div className='mt-3 mt-lg-2 p-0'>

                        {decodedData?.exam_type === "AKTHE" ? (
                          <img
                            src={AKTHECA1112}
                            alt="AKTHE - Cash awards"
                            className="desktopview img-fluid"
                          />
                        ) : (
                          <>
                          {Response?.profile?.stream === "SOE" ? (
                        <img src={ECAClass1112Engg} alt="cash awards" className='desktopview img-fluid' />
                        ) : (
                          <img src={ECAClass1112Medical} alt="cash awards" className='desktopview img-fluid' />
                        )}
                        </> 
                        )}
                      </div>
                    )}</> : <div style={{ height: "196px" }}></div>}
              </div>
            ) : (
              <div className='p-0'>
                {(Response?.scholarship?.allIndiaRank && Response?.profile?.class_studying && eligibleRankForCashAward[Response?.profile?.class_studying] && Number(Response?.scholarship?.allIndiaRank) <= eligibleRankForCashAward[Response?.profile?.class_studying]) ?
                  <> {Response?.profile?.class_studying == 'X' && (
                    <div className='mt-3 mt-lg-2 p-0'>
                      <img src={ECAClass10jrsr} alt="cash awards" className='desktopview img-fluid' />
                    </div>
                  )}
                    {/* For Class VII, VIII & IX Studying Students */}
                    {(Response?.profile?.class_studying == 'VII' || Response?.profile?.class_studying == 'VIII' || Response?.profile?.class_studying == 'IX') && (
                      <div className='mt-3 mt-lg-2 p-0'>
                        <img src={ECAClass789jrsr} alt="cash awards" className='desktopview img-fluid' />
                      </div>
                    )}
                    {/* For Class V, VI Studying Students */}
                    {(Response?.profile?.class_studying == 'V' || Response?.profile?.class_studying == 'VI') && (
                      <div className='mt-3 mt-lg-2 p-0'>
                        <img src={ECAClass56jrsr} alt="cash awards" className='desktopview img-fluid' />
                      </div>
                    )}
                    {/* For Class XI & XII Studying & XII Passed Students (Medical & Engineering Aspirants) */}
                    {(Response?.profile?.class_studying == "XI" || Response?.profile?.class_studying == 'XII' || Response?.profile?.class_studying == 'XII Passed') && (
                      <div className='mt-3 mt-lg-2 p-0'>
                        <img src={ECAClass1112jrsr} alt="cash awards" className='desktopview img-fluid' />
                      </div>
                    )}</> : <div style={{ height: "196px" }}></div>}
              </div>
            )}
          </Row>

          {/* {!isStudentPDF && (
            <>
              <Row>
                <div
                  className={`${styles.page1_ResultHead}  p-2 bg-dark-blue w-100 text-center text-white font-size-30`}
                >
                  CHECK LIST FOR COMPLETING ADMISSION FORMALITIES (OFFLINE
                  VISIT)
                </div>
                <Row className="w-100 m-auto p-0">
                  <Col
                    lg={12}
                    className={`${styles.page1_tableHead} dashed-border font-size-xl text-center `}
                  >
                    <h3 className="font-size-lg text-start my-2">
                      Please note that the following documents should be carried
                      along for completing the admission formalities at any
                      centre of Aakash in India:
                    </h3>
                    <Row lg={12} className="d-flex">
                      <Col lg={6}>
                        <ul
                          className={`${styles.page1_checklist} text-start font-size-md`}
                        >
                          <li>
                            <p>Latest Mark sheet</p>
                          </li>
                          <li>
                            <p>Two recent passport size colour photographs</p>
                          </li>
                        </ul>
                      </Col>
                      <Col lg={6}>
                        <ul
                          className={`${styles.page1_checklist} text-start font-size-md`}
                        >
                          <li>
                            <p>
                              A valid Photo-ID (Passport, School I-Card etc.)
                            </p>
                          </li>
                          <li>
                            <p>
                              A cheque book in case to avail installment payment
                              mode.
                            </p>
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Row>
              <Row className="text-center font-size-xxl bg-light-grey-100 justify-content-center my-4 p-2">
                SPECIAL ASSISTANCE AVAILABLE FOR COMPLETING ADMISSION
                FORMALITIES ONLINE.
              </Row>
              <Row>
                <Col lg={12} className="text-start mb-4">
                  <span className="fw-bold font-size-xl">Please note:</span>
                  <ul className={"text-start font-size-xl"}>
                    <li>
                      If at any point of time, the Govt. Charges GST/Service Tax
                      or any other tax on Scholarship granted, it will be borne
                      by the Student only.
                    </li>
                    <li>
                      The highest amount of scholarship will not exceed 100% of
                      the overall fee in any case whatsoever.
                    </li>
                  </ul>
                </Col>
              </Row>
            </>
          )} */}
          <Row
            className="d-flex flex-row-reverse"
          // style={{ position: "relative", top: "7rem" }}
          >
            <Col lg={10} className="p-0">
              <hr />
              <Col lg={12} className="d-flex">
                <Col className="dashed-borderRight font-size-sm me-1 pe-2 text-end">
                  <b>Corporate Office:</b> 3rd Floor, Incuspaze Campus – 2, Plot No. 13, Sector – 18, Udyog Vihar, Gurugram, Haryana - 122015
                  <br />
                  <b>Ph.:</b> +91-11–47623456 | <b>E-mail:</b> care@aesl.in
                </Col>
                <Col lg={3} className="d-flex justify-content-start ms-1">
                  <Col lg={2} className="me-3">
                    <img width={50} src={callIcon} />
                  </Col>
                  <Col className="d-flex flex-column text-start">
                    <span className="font-size-xs">TOLL FREE NUMBER </span>
                    <b className="font-size-xxl">1800-102-2727</b>
                  </Col>
                </Col>
              </Col>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default AntheResultPage1_Qualified;
